import { CountingSchemes } from '@ahaslides-product/frontend-toolkit'
import sentry from '@/3rd-parties/sentry'

const SEED_RETRIES = 1

const report = (error) => sentry.captureException(error)

const countingGroups = (slide) => [
  CountingSchemes.answerCountPerAnswerValue({
    slideId: slide.id,
    slideVersion: slide.version,
  }),
]

const countingActions = {
  subscribeCountingForSlideAction: ({ dispatch, getters }, { slide }) => {
    if (!getters.canReadAnswertextFromCounting || !slide?.id) return
    try {
      dispatch('counting/subscribe', {
        groups: countingGroups(slide),
        retries: SEED_RETRIES,
        onError: report,
      }, { root: true }).catch(report)
    } catch (error) {
      report(error)
    }
  },

  unsubscribeCountingForSlideAction: ({ dispatch }, { slide }) => {
    if (!slide?.id) return
    try {
      dispatch('counting/unsubscribe', {
        groups: countingGroups(slide),
      }, { root: true })
    } catch (error) {
      report(error)
    }
  },
}

export default countingActions
